import { ErrorResponse } from '@src/interface/api/response.interface'
import {
	getProductCouriers,
	GetProductCouriersResponse,
	Courier,
} from '@src/lib/api/product/getProductCouriers'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useGetProductCouriersQuery = (): UseQueryResult<
	GetProductCouriersResponse,
	AxiosError<ErrorResponse>
> => {
	return useQuery(
		['getProductCouriers'],
		() => {
			return getProductCouriers()
		},
		{ enabled: false, retry: 10 },
	)
}
export type { Courier, GetProductCouriersResponse } from '@src/lib/api/product/getProductCouriers'
export default useGetProductCouriersQuery
